module.exports = __webpack_public_path__ + "img/linux.1c139c33.png";